import { __require as requireFr } from "../node_modules/.pnpm/dayjs@1.11.13/node_modules/dayjs/locale/fr.js";
requireFr();
//# sourceMappingURL=fr.js.map
